'use client'

import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { ComingSoonDrawer } from './ComingSoonDrawer'

type ComingSoonDrawerContextValue = {
  isOpen: boolean
  open: () => void
  close: () => void
}

const ComingSoonDrawerContext =
  createContext<ComingSoonDrawerContextValue | null>(null)

export function ComingSoonDrawerProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  const value = useMemo(
    () => ({
      isOpen,
      open,
      close,
    }),
    [isOpen, open, close],
  )

  return (
    <ComingSoonDrawerContext.Provider value={value}>
      {children}
      <ComingSoonDrawer />
    </ComingSoonDrawerContext.Provider>
  )
}

export function useComingSoonDrawer() {
  const context = useContext(ComingSoonDrawerContext)

  if (!context) {
    throw new Error(
      'useComingSoonDrawer must be used within a ComingSoonDrawerProvider',
    )
  }

  return context
}
